<template>
  <div class="location_box">
    <div class="location col-12">
      <span class="step1">{{ step1 }}</span>
      <div class="arrow_wrap">
        <div class="arrow"></div>
      </div>
      <span class="step2">{{ step2 }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocationLine',
  computed: {
    step1: function () {
      return (this.$route.meta.step) ? this.$route.meta.step[0] : ''
    },
    step2: function () {
      return (this.$route.meta.step) ? this.$route.meta.step[1] : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.location_box {
  margin-top: 20px;
  padding: 0px 0px 0px 0px;

  .location {
    vertical-align: top;
    .step1 {
      display: inline-block;
      padding: 0px 5px 0px 0px;
    }

    .arrow_wrap {
      display: inline-block;
      padding: 0px 8px 0px 0px;
      vertical-align: bottom;

      .arrow {
        border: solid #b8b8b8;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 0.215rem;
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
      }
    }

    .step2 {
      display: inline-block;
      color: #007DEF;
    }
  }
}

</style>
